import React from 'react';

import { Number } from './Number';
import { SpecialNumber } from './SpecialNumber';

type Props = {
    readonly lineIndex: number;
    readonly betLinesIndex: number | null;
    readonly selected: boolean[];
    readonly disabled: boolean;
};

export function Numbers({ lineIndex, betLinesIndex, selected, disabled }: Props) {
    const getNormalLine = () => (
        <div className="row row-numbers no-gutters purchase-line-numbers">
            {['1', 'X', '2'].map((numberValue: string, index) => (
                <Number
                    key={lineIndex + index}
                    numberValue={numberValue}
                    lineIndex={lineIndex}
                    selected={selected[index]}
                    disabled={disabled}
                    betLinesIndex={betLinesIndex}
                />
            ))}
        </div>
    );

    const getSpecialLine = () => (
        <>
            <div className="row row-numbers no-gutters purchase-line-numbers">
                {['A0', 'A1', 'A2', 'AM'].map((numberValue: string, index) => (
                    <SpecialNumber
                        key={lineIndex + index + 'top'}
                        numberValue={numberValue}
                        lineIndex={lineIndex}
                        selected={selected[index]}
                        disabled={disabled}
                        betLinesIndex={betLinesIndex}
                    />
                ))}
            </div>
            <div className="row row-numbers no-gutters purchase-line-numbers">
                {['B0', 'B1', 'B2', 'BM'].map((numberValue: string, index) => (
                    <SpecialNumber
                        key={lineIndex + index + 'bottom'}
                        numberValue={numberValue}
                        lineIndex={lineIndex}
                        selected={selected[index + 4]}
                        disabled={disabled}
                        betLinesIndex={betLinesIndex}
                    />
                ))}
            </div>
        </>
    );

    return lineIndex === 14 ? getSpecialLine() : getNormalLine();
}
